import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { SearchInput } from '@dev/ee-components';
import { SearchProps } from '../CustomFields';

const SearchContainer = styled.div`
    padding: 24px 48px;
`;

export const SearchComponent = (props: SearchProps): JSX.Element => {
    const { t } = useTranslation();
    const { search, setActivePage, setSearch } = props;

    const handleSearchValue = (event?): void => {
        setActivePage(1);
        setSearch(event ? event.currentTarget.value : '');
    };

    return (
        <SearchContainer>
            <SearchInput
                id="search-for-fields-input"
                label=""
                placeholder={t('searchforfields')}
                type="text"
                defaultValue={search}
                onChange={handleSearchValue}
                onDelete={handleSearchValue}
            />
        </SearchContainer>
    );
};
